import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileSubTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VListTile,{key:_vm.notif.id,attrs:{"avatar":""}},[_c(VAvatar,[_c('img',{attrs:{"src":"/img/soramaru/08_fun.png"}})]),_c(VListTileContent,{staticStyle:{"margin-left":"10px"}},[_c(VListTileSubTitle,[_vm._v("\n      レベルが\n      "),_c('b',[_vm._v(_vm._s(_vm.notif.data.level))]),_vm._v("に上がりました！\n    ")]),_c(VListTileSubTitle,[_vm._v(_vm._s(_vm.$moment(_vm.notif.timestamp.seconds*1000).format("YYYY-MM-DD HH:mm")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }